import { Box, Button, Typography } from '@mui/material';
import React from 'react';

import ImageNoItems from '../../../assets/images/no-items-created-placeholder.svg';

import { TableEmptyStateWrapper } from './TableEmptyStateWrapper';

interface ITableEmptyPlaceholderProps {
  item: string;
  subtitle: string;
  buttonText?: string;
  onButtonClick?: () => void;
  title?: string;
}

export const TableEmptyPlaceholder = ({
  item,
  subtitle,
  buttonText,
  onButtonClick,
  title,
}: ITableEmptyPlaceholderProps) => {
  return (
    <TableEmptyStateWrapper>
      <img src={ImageNoItems} alt={`No ${item} found`} />
      <Box sx={{ width: '100%' }}>
        <Typography variant="h5" sx={{ mb: 1.5 }}>
          {title ?? `No ${item} yet`}
        </Typography>
        <Typography>{subtitle}</Typography>
        {buttonText && onButtonClick && (
          <Box sx={{ width: '100%', textAlign: 'center' }}>
            <Button variant="contained" onClick={onButtonClick} sx={{ mt: 3, mr: 'auto', ml: 'auto' }}>
              {buttonText}
            </Button>
          </Box>
        )}
      </Box>
    </TableEmptyStateWrapper>
  );
};
